<div
  class="c__closed-container {{data?.isOpen || data?.isSlice ? 'is-open is-visually-hidden' : ''}}"
  [attr.aria-hidden]="data?.isOpen || data?.isSlice"
>
  <div
    class="c__closed-content"
    [@fadeInOutDelayIn]="(data?.isOpen || data?.isSlice) ? '0' : '1'"
    [@displayInOut]="(data?.isOpen || data?.isSlice) ? 'none' : 'flex'"
  >
    <ng-container *ngTemplateOutlet="title" />
    @if (!isLoading) {
      <div class="c__btn-container">
        <button sd-button
          #openButton
          class="is-full-area"
          tabindex="0"
          type="button"
          role="button"
          [brand]="brand"
          icon="icon-arrow-right"
          [attr.aria-expanded]="!!data.isOpen"
          [isIcon]="true"
          (click)="clickToOpen(indexSlice)"
        >
          <span class="is-visually-hidden">
            {{'actions.open' | translate}} - {{data?.headTitle ? data?.headTitle : indexSlice}}
          </span>
        </button>
      </div>
    }
  </div>
  @if (data?.media) {
    <sd-banner
      [isComponentLoading]="isLoading"
      #backgroundSlice
      class="c__background"
      (imageIsLoaded)="imageLoaded()"
      [hasAltText]="false"
      [@fadeInOutBg]="(data?.isOpen || data?.isSlice) ? '0' : '1'"
      [@displayInOut]="(data?.isOpen || data?.isSlice) ? 'none' : 'block'"
      [media]="newData?.media || data?.media"
      [imgRatio]="isMobile$ ? imageRatioEnum.r14_9
        : slicesNumber === 3 ? imageRatioEnum.r4_3
        : slicesNumber === 4 ? imageRatioEnum.r1_1
        : slicesNumber === 5 ? imageRatioEnum.r5_4
        : imageRatioEnum.default"
    />
  }
</div>

<div class="c__opened-container">
  <div
    class="c__header-slice"
    [@fadeInOutDelayIn]="data?.isSlice ? '1' : '0'"
    [@displayInOut]="data?.isSlice ? 'flex' : 'none'"
    [attr.aria-hidden]="!data?.isSlice"
  >
    @if (data?.headTitle) {
      <sd-title
        [titleLevel]="data?.titleLevel + 1"
        customClass="c__headline is-full-area"
        (click)="clickToOpen(indexSlice)"
      >
        <button
          class="c__btn-slice is-full-area brand--h4 is-regular"
          type="button"
          role="button"
          [attr.aria-expanded]="data?.isOpen"
        >
          {{data?.headTitle}}
        </button>
      </sd-title>
    }
  </div>
  <div
    class="c__opened-content"
    [@fadeInOutDelayIn]="data?.isOpen ? '1' : '0'"
    [@displayInOut]="data?.isOpen ? 'block' : 'none'"
    [attr.aria-hidden]="!data?.isOpen"
  >
    <button sd-button
      #closeButton
      class="c__close"
      tabindex="0"
      type="button"
      role="button"
      [brand]="brand"
      [theme]="themesEnum.dark"
      icon="icon-cross"
      [isIcon]="true"
      (click)="clickToClose(indexSlice)"
    >
      <span class="is-visually-hidden">
        {{'actions.close' | translate}} - {{data?.headTitle ? data?.headTitle : indexSlice}}
      </span>
    </button>
    <div class="c__wrapper">
      <ng-container *ngTemplateOutlet="title" />
      @if (data?.description) {
        <sd-html innerClass="c__description is-wysiwyg is-medium" [html]="data?.description" />
      }

      @if (data?.link) {
        <sd-link
          customClass="c__link"
          [brand]="brand"
          [isButton]="true"
          [link]="data?.link"
          [isSmall]="isMobile$"
          (clicked)="clickToUrl()"
        >
          {{ data?.link?.linkName }}
        </sd-link>
      }
    </div>
  </div>
</div>

<ng-template #title>
  @if (!isLoading) {
    @if (data.headTitle) {
      <sd-title
        [titleLevel]="data.titleLevel + 1"
        [customClass]="data?.isOpen ? 'brand--h5vc__headline' : 'brand--h6 c__headline'"
      >
        {{data.headTitle}}
      </sd-title>
    }
    @if (data.title) {
      <sd-title
        [titleLevel]="data.titleLevel"
        [customClass]="data?.isOpen ? 'brand--h3 c__title' : 'brand--h4 c__title'"
      >
        {{data.title}}
      </sd-title>
    }
  }

  @if (isLoading) {
    <sd-skeleton
      [appearance]="skeletonAppearanceEnum.heading"
      [center]="true"
      [sizeChangeMobile]="false"
      [count]="0"
    />
  }
</ng-template>
